var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgView"},[_c('el-image-viewer',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgViewShow),expression:"imgViewShow"}],attrs:{"url-list":_vm.imgList,"on-close":_vm.closeImgView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }